import * as React from 'react';
import Typography from '@material-ui/core/Typography';
import { TemplateSection, TemplateContainerProps } from '../typings';
import TemplateSectionContainer from './TemplateSectionContainer';
import { setTemplateValues } from '../utils/templateValues';

const DesktopFormContainer: React.FC<TemplateContainerProps> = ({ templateDetails, templateLanguage }) => {
  setTemplateValues(templateDetails);
  const { name, templateSections } = templateDetails;
  return (
    <div style={{ padding: '1rem' }}>
      <Typography variant='h6'>{name}</Typography>
      <br />
      {templateSections.map((eachSection: TemplateSection) => (
        <div key={eachSection.rank}>
          <TemplateSectionContainer isMobile={false} templateSection={eachSection} templateLanguage={templateLanguage} />
        </div>
      ))}
    </div>
  );
};

export default DesktopFormContainer;
